import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider } from './Context';
import { TranslationProvider } from './TranslationContext';
import { motion } from 'framer-motion';
import Layout from "./pages/Layout";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import Choices from "./pages/Choices";
import Checkout from "./pages/Checkout";
import Confirm from "./pages/Confirm";
import PaymentComplete from "./pages/PaymentComplete";
import NoPage from "./pages/NoPage";
import LanguageBanner from './pages/functions/LanguageBanner';

export default function App() {
	const psServer = "./psServer"; //dev
	//const psServer = "http://localhost/psServer"; // dev
	const [serverConfig, setServerConfig] = useState({});
	const [isReady, setIsReady] = useState(false);
	const [siteTitle, setSiteTitle] = useState(() => {
		const rawTitle = window.injectedSiteTitle;
		const isPlaceholder = rawTitle === "Vega Download";
		return isPlaceholder ? "" : rawTitle;
	});
	useEffect(() => {
		const initializeApp = async () => {
			try {
				const response = await fetch(psServer + "/config", {
					method: 'GET',
					headers: {
						'Content-Type': 'application/json',
					}
				});
				let data = await response.json();
				if (!data) {
					throw new Error('Error with config');
				}
				if (siteTitle === "" && data.siteTitle) {
					setSiteTitle(data.siteTitle);
					document.title = data.siteTitle;
				}
				setServerConfig(data);
				setIsReady(true);
			} catch (error) {
				console.error('Config:', error);
			}
		};
		initializeApp();
	}, []);
	
	return (
		<>
			{isReady ? (
				<BrowserRouter>
					<AppProvider config={serverConfig} psServer={psServer}>
						<TranslationProvider>
							<LanguageBanner />
							<motion.div
								initial={{ opacity: 0 }}
								animate={{ opacity: 1 }}
								exit={{ opacity: 0 }}
								transition={{ duration: 1, ease: "easeInOut" }}
								className="mainWrap"
							>
								<Routes>
									<Route path="/" element={<Layout />}>
										<Route index element={<Home />} />
										<Route path="gallery" element={<Gallery />} />
										<Route path="choices" element={<Choices />} />
										<Route path="checkout" element={<Checkout />} />
										<Route path="confirm" element={<Confirm />} />
										<Route path="success" element={<PaymentComplete />} />
										<Route path="failed" element={<PaymentComplete />} />
										<Route path="*" element={<NoPage />} />
									</Route>
								</Routes>
							</motion.div>
						</TranslationProvider>
					</AppProvider>
				</BrowserRouter>
			) : (
				<div style={{
						display: "flex",
						width: "100vw",
						height: "100vh",
						color: "#000000",
						backgroundColor: "#FFFFFF",
						justifyContent: "center",
						alignItems: "center"
				}}>Please Wait...</div>
			)}
		</>
	);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);